import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'

const BenefitStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const BenefitIconStyled = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 0.625rem;
  justify-content: center;
  height: 3.5rem;

  @media ${media.phone} {
    height: 4.25rem;
  }
`

const BenefitTextStyled = styled.div`
  text-align: center;
`

export { BenefitStyled, BenefitIconStyled, BenefitTextStyled }
